// Carrier Type
export enum CarrierType {
  PLATFORM_MANAGED = 'platform_managed',
  INTEGRATED = 'integrated'
}

// Contact Info
export interface ContactInfo {
  email?: string;
  phone?: string;
  address?: string;
}

export type CarrierStatus = 'pending_review' | 'approved' | 'onboarding' | 'active' | 'suspended';

export const CARRIER_STATUS_LABELS: Record<CarrierStatus, string> = {
  pending_review: 'بانتظار المراجعة',
  approved: 'معتمد',
  onboarding: 'قيد الإعداد',
  active: 'نشط',
  suspended: 'موقوف',
};

export const CARRIER_STATUS_COLORS: Record<CarrierStatus, string> = {
  pending_review: 'bg-yellow-500/10 text-yellow-600 border-yellow-500/20',
  approved: 'bg-blue-500/10 text-blue-600 border-blue-500/20',
  onboarding: 'bg-purple-500/10 text-purple-600 border-purple-500/20',
  active: 'bg-green-500/10 text-green-600 border-green-500/20',
  suspended: 'bg-red-500/10 text-red-600 border-red-500/20',
};

// Carrier
export interface Carrier {
  id: string;
  name: string;
  type: CarrierType;
  logo_url?: string;
  contact_info?: ContactInfo;
  created_by_tenant_id?: string;
  is_guaranteed_payout: boolean;
  payout_duration_in_hours: number;
  wallet_balance: number;
  credit_limit: number;
  is_active: boolean;
  status: CarrierStatus;
  onboarding_step: number;
  created_at: string;
  updated_at: string;
}

// Create Carrier DTO
export interface CreateCarrierDto {
  name: string;
  type: CarrierType;
  logo_url?: string;
  contact_info?: ContactInfo;
  created_by_tenant_id?: string;
  is_guaranteed_payout?: boolean;
  payout_duration_in_hours?: number;
  wallet_balance?: number;
  credit_limit?: number;
  is_active?: boolean;
}

// User Role
export enum UserRole {
  ADMIN = 'admin',
  TENANT = 'tenant',
  CARRIER = 'carrier'
}

// Create Carrier User DTO
export interface CreateCarrierUserDto {
  email: string;
  password: string;
  role: UserRole;
  carrier_id?: string;
  tenant_id?: string;
}

// Carrier Type Labels
export const CARRIER_TYPE_LABELS: Record<CarrierType, string> = {
  [CarrierType.PLATFORM_MANAGED]: 'مُدار من المنصة',
  [CarrierType.INTEGRATED]: 'متكامل'
};

// User Role Labels
export const USER_ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.ADMIN]: 'مدير النظام',
  [UserRole.TENANT]: 'شريك',
  [UserRole.CARRIER]: 'ناقل'
};
